import Card from "react-bootstrap/Card";

function CardComponent({title, subTitle, bgColor, textColor, size, children}) {
  return (
    <Card
      bg={bgColor}      
      text={textColor}
      style={{ width: size, backgroundColor: bgColor}}
      className="mb-2"
    >
      <Card.Header>{title}</Card.Header>
      <Card.Body>
        <Card.Title>{subTitle} </Card.Title>
        <Card.Text>
          {children}
        </Card.Text>
      </Card.Body>
    </Card>
  );
}

export default CardComponent;
